import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";

import {
    faDownload,
    faPlus,
    faSearch,
  } from "@fortawesome/free-solid-svg-icons";
  import "../style/ExpenseReport.css";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import moment from "moment";
  import { Link, useLocation } from "react-router-dom";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  
  const convert = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  };
  
  const FormatDate = (inp) => {
    let dateformat = inp.split("T")[0];
    const date = moment(dateformat, "YYYY-MM-DD");
    return date.format("DD-MMM-YYYY");
  };

const MaintenanceReport = () => {
    const location = useLocation();
  const passedState = location.state;
  const [maintenanceList, setMaintenanceList] = useState([]);
  const [buses, setBuses] = useState([]);
  const [busName, setBusName] = useState(null);
  const [isDateInput, setIsDateInput] = useState([]);
  const [currenttime, setCurrenttime] = useState("");
  const DateTime = () => {
    const date = new Date();
    let y = date.toString();
    let todayDate = y.split(" ")[2];
    let thisMonth = y.split(" ")[1];
    let thisYear = y.split(" ")[3];
    let time = y.split(" ")[4];
    let noon = time.split(":")[0] >= 12 ? "PM" : "AM";
    let space = "  ";
    //   //console.log(y.split(" ")[2],y.split(" ")[1],y.split(" ")[3]," ",y.split(" ")[4],time.split(":")[0] >=12 ? "PM" : "AM");
    let final = (
      y.split(" ")[2] +
      "-" +
      y.split(" ")[1] +
      "-" +
      y.split(" ")[3] +
      " " +
      y.split(" ")[4] +
      " " +
      noon
    ).toString();
    setCurrenttime(final);
  };

  const InitState = {
    BusId: null,
    BusName:null,
    Start_Date: null,
    End_Date: null,
    user: passedState.username,
  };

  const [formData, setFormData] = useState(InitState);

  async function getBase64ImageFromUrl(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        //console.log(reader.result);
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

//   const exportPDF = async () => {
//     if (formData.BusId === null) {
//       WarningMSG("Fill BusId Fields");
//     } else {
//       const doc = new jsPDF();
//       var Y = 0;
//       doc.setFontSize(16);
//       doc.setTextColor("#4776E6");
//       doc.text("Aathirran Travels", 85, (Y = Y + 10));
//       doc.setTextColor("#000000");
//       doc.setFontSize(8);
//       doc.text(currenttime, 140, Y);
//       doc.setFontSize(16);
//       if (maintenanceList.length > 0) {
//         doc.text("Maintenance Report", 80, (Y += 20));
//         doc.autoTable({
//             head: [['Reg.no', 'Service Provider', 'Maintenance Date', 'Reason', 'Next Service Date', 'Total Amount']],
//             body: maintenanceList.map((item) => [
//               item.Register_Number,
//               item.Service_Provider,
//               item.Maintenance_Date ? FormatDate(item.Maintenance_Date) : '-',
//               item.Reason,
//               item.Next_Service_Date ? FormatDate(item.Next_Service_Date) : '-',
//               item.Total_Amount ?? '-',
//             ]),
//             startY: Y + 5,
//             styles: { fontSize: 8 },
//           });
          
//         doc.setFontSize(16);
//       }

//       doc.save("maintenanceReport.pdf");
//     }
//   };

const exportPDF = async () => {
    if (formData.BusId === null) {
      WarningMSG("Fill BusId Fields");
    } else {
      const doc = new jsPDF();
      let Y = 10;
  
      // Ensure currenttime is a valid string
      const currenttime = new Date().toLocaleString(); // This formats the date to a readable string
      console.log("Current Time:", currenttime); // Log currenttime to console for debugging
  
      // Title
      doc.setFontSize(16);
      doc.setTextColor("#4776E6");
      doc.text("Aathirran Travels", 85, Y);
  
      // Reset styles for content
      doc.setFontSize(12);
      doc.setTextColor("#000000");
  
      Y += 10; // Add spacing after title
      doc.text("Maintenance Report", 80, Y);

      // Reset styles for content
      doc.setFontSize(8);
      doc.setTextColor("#000000");

      Y += 5;
      doc.text(`User : ${passedState.username}`, 140, Y);
  
      // Display current time
      Y += 5; // Increase Y position slightly
      doc.text(`Date : ${currenttime}`, 140, Y); // This should now display the correct current time
  
       // Further spacing
      doc.text(`Bus Name : ${busName ? busName : "-"}`, 15, Y);
  
      if (maintenanceList.length > 0) {
        // Prepare table headers
        const headers = [
          ["Reg.no", "Service Provider", "Maintenance Date", "Reason", "Next Service Date", "Total Amount"]
        ];
  
        // Prepare table body
        let total = 0;
        const data = maintenanceList.map((item) => {
          const amt = item.Total_Amount ? Number(item.Total_Amount) : 0;
          total += amt;
          return [
            item.Register_Number || "-",
            item.Service_Provider || "-",
            item.Maintenance_Date ? FormatDate(item.Maintenance_Date) : "-",
            item.Reason || "-",
            item.Next_Service_Date ? FormatDate(item.Next_Service_Date) : "-",
            item.Total_Amount || "-"
          ];
        });
  
        // Add total row
        data.push(["", "", "", "", "Total", total.toFixed(2)]);
  
        // Draw table
        doc.autoTable({
          head: headers,
          body: data,
          startY: (Y += 5),
          styles: { fontSize: 8 },
          theme: 'grid',
          headStyles: {
            fillColor: [71, 118, 230], // #4776E6
            textColor: 255,
            halign: 'center',
          },
        });
      } else {
        Y += 10;
        doc.text("No maintenance data available.", 15, Y);
      }
  
      // Save PDF
      doc.save("maintenanceReport.pdf");
    }
  };
  
  
  
  const FetchBusList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/bus/FetchBusList`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    setBuses(response.data);
  };

  useEffect(() => {
    FetchBusList();
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleChange = (e) => {
    const selectedBusName = e.target.options[e.target.selectedIndex].text;
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setBusName(selectedBusName)
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formData.BusId === null) {
      WarningMSG("Fill Bus Field");
    } else {
      try {
        console.log("formData:", formData);
        await axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/tripclosure/MaintenanceReport`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              console.log("report:", res.data);
              setMaintenanceList(res?.data?.maintance ?? []);
              if (
                res.data.maintance.length === 0
              ) {
                WarningMSG("No Records Found");
              }
            } else {
              FailedMSG("Failed to Fetch");
            }
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
    }
  };
  let maintenanceTotal = 0;
  return (
    <>
    <ToastContainer />
    <Appbar
      username={passedState.username}
      rights={passedState.rights}
    ></Appbar>
    <div className="ExpenseReport">
      <Menu
        username={passedState.username}
        rights={passedState.rights}
        i={"Report"}
      ></Menu>
      <div className="ExpenseReportPage">
        <p className="ExpenseReportHeadLabel">Maintenance Report</p>
        <div className="ExpenseReportHeaders">
          <div className="ExpenseReportRegSearch1">
            <select
              className="ExpenseReportFormInputs"
              name="BusId"
              value={formData.BusId}
              onChange={handleChange}
            >
              <option value="">Select Bus</option>
              {buses.length > 0
                ? buses.map((bus, index) => (
                    <option key={index} name="BusId" value={bus.Bus_Id}>
                      {bus.Bus_Name}
                    </option>
                  ))
                : null}
            </select>

            <button onClick={handleSubmit} className="ExpenseReportSearchBtn">
              <FontAwesomeIcon
                className="ExpenseReportRegSearchIcon"
                title="Search"
                icon={faSearch}
              ></FontAwesomeIcon>
            </button>
          </div>
          <button
            className="NewExpenseReportBtn"
            title="Add New"
            onClick={exportPDF}
          >
            Export PDF
            <FontAwesomeIcon
              className="ExpenseReportAddNewIcon"
              icon={faDownload}
            ></FontAwesomeIcon>
          </button>
        </div>
        <div className="ExpenseReportLists">
          {maintenanceList && maintenanceList.length > 0 ? (
            <>
              <t4 className="ExpenseReportLables">Maintenance Report</t4>
              <table id="ExpenseTable">
                <thead>
                  <tr>
                    <td>Reg.no</td>
                    <td>Service Provider</td>
                    <td>MaintenanceDate</td>
                    <td>Reason</td>
                    <td>NextServiceDate</td>
                    <td>TotalAmount</td>
                  </tr>
                </thead>
                <tbody>
                  {maintenanceList.length > 0 &&
                    maintenanceList.map((items, i) => {
                      if (items.Total_Amount != null) {
                        maintenanceTotal =
                          maintenanceTotal + Number(items.Total_Amount);
                      }
                      return (
                        <tr>
                          <td>{items.Register_Number}</td>
                          <td>{items.Service_Provider}</td>
                          <td>
                            {items.Maintenance_Date === null
                              ? "-"
                              : items.Maintenance_Date
                              ? FormatDate(items.Maintenance_Date)
                              : items.Maintenance_Date}
                          </td>
                          <td>{items.Reason}</td>
                          <td>
                            {items.Next_Service_Date === null
                              ? "-"
                              : items.Next_Service_Date
                              ? FormatDate(items.Next_Service_Date)
                              : items.Next_Service_Date}
                          </td>
                          <td>
                            {items.Total_Amount === null
                              ? "-"
                              : items.Total_Amount}
                          </td>
                          
                        </tr>
                      );
                    })}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total </td>
                    <td>{maintenanceTotal}</td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : null}
          {
          (maintenanceList.length === 0) ? (
            <p>No Maintenance Found</p>
          ) : null}
        </div>
      </div>
    </div>
    <Footer></Footer>
  </>
  )
}

export default MaintenanceReport